import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class OrderCompleteGuard {
  private document = inject<Document>(DOCUMENT);
  private router = inject(Router);
  private storageService = inject(StorageService);

  /**
   * Determines if the order complete page should be loaded.
   */
  public canActivate(): boolean {
    if (!!this.storageService.transactionId && this.storageService.addressComplete) {
      if (this.storageService.betterLab && !this.storageService.free) {
        this.router.navigate(['betterlab.php']);

        return false;
      }

      return true;
    }

    if (!environment.order.navigateToOrderAddressRoute) {
      this.document.location.href = environment.siteUrls.tests;

      return false;
    }

    this.router.navigate(['order-address.php']);

    return false;
  }
}
